import React, { useState } from "react";
import { Dropdown, Badge } from "react-bootstrap";
import { projectStatusOptions } from "../../../utils/constant";

const ProjectFilterComponent = ({ appliedFilters = [], onApplyFilters }) => {
  const [draft, setDraft] = useState([...appliedFilters]);
  const [open, setOpen] = useState(false);

  const handleToggle = (nextOpen) => {
    if (nextOpen) setDraft([...appliedFilters]);
    setOpen(nextOpen);
  };

  const handleFilterChange = (e) => {
    const value = e.target.value;
    if (e.target.checked) {
      setDraft((d) => (d.includes(value) ? d : [...d, value]));
    } else {
      setDraft((d) => d.filter((item) => item !== value));
    }
  };

  const handleApply = () => {
    onApplyFilters?.(draft);
    setOpen(false);
  };

  const n = appliedFilters.length;

  return (
    <Dropdown show={open} onToggle={handleToggle} align="start" className="dropdown">
      <Dropdown.Toggle
        variant=""
        className="me-2 btn add-btn btn-outline-primary d-flex align-items-center text-uppercase i-false position-relative"
      >
        {n > 0 ? (
          <Badge
            pill
            bg="danger"
            className="position-absolute top-0 start-100 translate-middle"
            style={{ fontSize: "0.65rem", zIndex: 1 }}
          >
            {n}
          </Badge>
        ) : null}
        <span className="me-2">Filter</span>
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.25 12.6669H8.895M4.534 12.6669H2.75M4.534 12.6669C4.534 12.0887 4.76368 11.5342 5.17251 11.1254C5.58134 10.7166 6.13583 10.4869 6.714 10.4869C7.29217 10.4869 7.84666 10.7166 8.25549 11.1254C8.66432 11.5342 8.894 12.0887 8.894 12.6669C8.894 13.2451 8.66432 13.7995 8.25549 14.2084C7.84666 14.6172 7.29217 14.8469 6.714 14.8469C6.13583 14.8469 5.58134 14.6172 5.17251 14.2084C4.76368 13.7995 4.534 13.2451 4.534 12.6669ZM21.25 19.2739H15.502M15.502 19.2739C15.502 19.8522 15.2718 20.4073 14.8628 20.8162C14.4539 21.2252 13.8993 21.4549 13.321 21.4549C12.7428 21.4549 12.1883 21.2242 11.7795 20.8154C11.3707 20.4065 11.141 19.8521 11.141 19.2739M15.502 19.2739C15.502 18.6956 15.2718 18.1415 14.8628 17.7325C14.4539 17.3236 13.8993 17.0939 13.321 17.0939C12.7428 17.0939 12.1883 17.3236 11.7795 17.7324C11.3707 18.1412 11.141 18.6957 11.141 19.2739M11.141 19.2739H2.75M21.25 6.05988H18.145M13.784 6.05988H2.75M13.784 6.05988C13.784 5.48171 14.0137 4.92722 14.4225 4.51839C14.8313 4.10956 15.3858 3.87988 15.964 3.87988C16.2503 3.87988 16.5338 3.93627 16.7983 4.04583C17.0627 4.15538 17.3031 4.31596 17.5055 4.51839C17.7079 4.72082 17.8685 4.96114 17.9781 5.22563C18.0876 5.49012 18.144 5.7736 18.144 6.05988C18.144 6.34616 18.0876 6.62964 17.9781 6.89413C17.8685 7.15862 17.7079 7.39894 17.5055 7.60138C17.3031 7.80381 17.0627 7.96439 16.7983 8.07394C16.5338 8.1835 16.2503 8.23988 15.964 8.23988C15.3858 8.23988 14.8313 8.0102 14.4225 7.60138C14.0137 7.19255 13.784 6.63805 13.784 6.05988Z"
            stroke="#555555"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </svg>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu timeline-panel">
        {projectStatusOptions.map((status, index) => (
          <Dropdown.Item
            key={index}
            className="dropdown-item pointer-cursor"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="form-check custom-checkbox check-lg me-3 ps-0"
              onClick={(e) => e.stopPropagation()}
            >
              <input
                onChange={handleFilterChange}
                type="checkbox"
                className="form-check-input m-0"
                id={`customCheckBox${index}`}
                value={status}
                checked={draft.includes(status)}
              />
              <label className="form-check-label" htmlFor={`customCheckBox${index}`}>
                {status}
              </label>
            </div>
          </Dropdown.Item>
        ))}
        <div className="d-flex justify-content-end p-2">
          <button type="button" className="btn me-2 btn-primary px-4 py-2" onClick={handleApply}>
            Apply
          </button>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProjectFilterComponent;
